import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { initSentry, SentryErrorBoundary } from './sentry';

initSentry();

function ErrorFallback() {
  return (
    <div style={{ padding: 24, fontFamily: 'system-ui' }}>
      <h1>Something went wrong</h1>
      <p>Please reload the page or contact support if this keeps happening.</p>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </SentryErrorBoundary>
  </StrictMode>
);
